"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_universal_component_1 = require("react-universal-component");
var errorHandler_1 = require("../../common/service/errorHandler");
var MinimalLoader_1 = require("../../../common/components/presentation/MinimalLoader/MinimalLoader");
var ThemedErrorMessage_1 = require("../../../common/components/presentation/Error/ThemedErrorMessage");
var GqlDeferredReserveOnlineConfirmation = react_universal_component_1.default(function () { return Promise.resolve().then(function () { return require(/* webpackChunkName: "enquiry-form-confirmation" */ './components/ReserveOnlineConfirmationScreen'); }); }, {
    loading: function () { return <MinimalLoader_1.default />; },
    error: function (props) {
        errorHandler_1.default.handleError(props.error);
        return (<ThemedErrorMessage_1.default fullPage={true} message={'Failed loading continue in dealership screen.'} error={props.error}/>);
    },
});
exports.default = GqlDeferredReserveOnlineConfirmation;
